import { PROFILE_VIEW_STATE_UPDATED } from '../actions/EbProfileViewActions';

// This is our apps initial state
// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  return {
    ebProfileViewState: {
      key_influencers_expanded: true,
      key_indicators_expanded: false,
      location_expanded: false,
    },
  };
};

function EbProfileViewReducer(state = getInitialState(), action) {
  switch (action.type) {
    case PROFILE_VIEW_STATE_UPDATED:
      return {
        ...state,
        ebProfileViewState: Object.assign(state.ebProfileViewState, action.ebProfileViewState),
      };
    default:
      return state;
  }
}

export default EbProfileViewReducer;
